import { render, staticRenderFns } from "./VaIconFaster.vue?vue&type=template&id=52aa8296&"
import script from "./VaIconFaster.vue?vue&type=script&lang=js&"
export * from "./VaIconFaster.vue?vue&type=script&lang=js&"
import style0 from "./VaIconFaster.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports